"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSectionItem = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _utils = require("../../utils");
var _useControlledQuantityPicker = require("./useControlledQuantityPicker");
var _useRemoveHandler = require("./useRemoveHandler");
const useSectionItem = props => {
  const {
    item,
    sectionMiniBagProps,
    itemsX
  } = props;
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    basketItemTranslations,
    basketItemTranslationsNamespace,
    isConsultant,
    isDiscounted
  } = sectionMiniBagProps;
  const [initialQuantity, setInitialQuantity] = (0, _react.useState)(-1);
  const {
    canBeDeleted,
    canBeReduced,
    itemCode,
    itemDescription,
    itemType,
    lineNumber,
    maxQuantity,
    quantity,
    requestedQuantity
  } = item;
  const partialId = `${lineNumber}-${itemCode}-${itemType}`;
  (0, _logger.logDebug)(`Ⓜ️ ${partialId}`);
  const splitoutRequestedQuantity = (0, _react.useMemo)(() => {
    if (itemType === 'X' || !itemsX || itemsX.length === 0) {
      return undefined;
    }
    const requestedQuantityX = itemsX.filter(i => i.itemCode === itemCode && i.lineNumber !== lineNumber).reduce((total, current) => total + current.requestedQuantity, 0);
    return requestedQuantityX > 0 ? requestedQuantityX : undefined;
  }, [itemCode, itemType, itemsX, lineNumber]);

  // delete button
  const {
    removeItemHandler
  } = (0, _useRemoveHandler.useRemoveHandler)({
    itemCode,
    lineNumber,
    outOfStock: requestedQuantity > quantity,
    requestedQuantity
  });

  // quantity stuff
  const {
    onQuantityChange
  } = (0, _useControlledQuantityPicker.useControlledQuantityPicker)({
    canBeDeleted,
    canBeReduced,
    initialQuantity,
    itemCode,
    lineNumber,
    maxQuantity,
    quantity,
    removeItemHandler
  });
  (0, _react.useEffect)(() => {
    setInitialQuantity(prev => prev === -1 ? quantity : prev);
  }, [quantity]);

  // map item to basket item
  const basketItem = (0, _react.useMemo)(() => {
    const data = (0, _utils.mapShoppingBagItem)({
      item,
      commonProps: {
        testId: `${getTestId('item')}-${partialId}`,
        isBrandPartner: isConsultant,
        isDiscounted,
        basketItemTranslations,
        basketItemTranslationsNamespace,
        initialQuantity
      }
    });
    data.requestedQuantitySplitout = splitoutRequestedQuantity;
    data.buttons = {
      remove: {
        text: formatMessage('delete'),
        title: `${formatMessage('delete')} ${itemDescription}`,
        visible: true,
        onClick: removeItemHandler
      }
    };
    data.onQuantityChange = onQuantityChange;
    return data;
  }, [basketItemTranslations, basketItemTranslationsNamespace, formatMessage, getTestId, initialQuantity, isConsultant, isDiscounted, item, itemDescription, onQuantityChange, partialId, removeItemHandler, splitoutRequestedQuantity]);
  return {
    basketItem
  };
};
exports.useSectionItem = useSectionItem;
